Namespace 'Common'

class Common.SubtypeToTypeTranslator
  translate: (subtype) ->
    @translations[subtype] or throw new Error "Cannot translate subtype #{subtype} to any known type"

  translations:
    'fb-post': 'facebook'
    'fb-comment': 'facebook'
    'fb-message': 'facebook'
    'fb-user': 'facebook'
    'tweet': 'twitter'
    'retweet': 'twitter'
    'direct-message': 'twitter'
    'quote': 'twitter'
    'tw-user': 'twitter'
    'ig-image': 'instagram'
    'ig-video': 'instagram'
    'ig-live': 'instagram'
    'ig-comment': 'instagram'
    'ig-comment-live': 'instagram'
    'ig-user': 'instagram'
    'yt-comment': 'youtube'
    'yt-user': 'youtube'
    'email': 'email'
    'email-user': 'email'
    'webchat': 'webchat'
    'webchat-start': 'webchat'
    'webchat-message': 'webchat'
    'whatsapp': 'whatsapp'
    'whatsapp_message': 'whatsapp'
    'whatsapp_message-user': 'whatsapp'
    'gp_review_comment': 'google_play'
    'apple_app_store_review_comment': 'google_play'
    'li-post': 'linkedin'
    'li-comment': 'linkedin'
    'li-user': 'linkedin'
    'google_search_result': 'google_search'
    'instagram_listening_media': 'instagram'
    'google-my-business-review': 'google-my-business'
    'google-my-business-reply': 'google-my-business'
    'tiktok-ad': 'tiktok'
    'tiktok-comment': 'tiktok'
    'tiktok-post': 'tiktok'
    'tiktok-user': 'tiktok'
